<div class="ng-header display-laptop">
    <div class="ng-header-left left">
        <div class="toggle-menu-button left">
            <a class="icon" (click)="toggleMenu()" tabindex="-1"><i class="fa fa-bars"></i></a>
        </div>
    </div>
    <div class="ng-header-left right p-align-center">
        <div class="right">
            <a class="icon" (click)="logout()"  tabindex="-1"><i class="fa fa-sign-out-alt" pTooltip="Log out" tooltipPosition="left"></i></a>
        </div>
        <div class="right">
            <a class="icon" (click)="guildLine()"  tabindex="-1"><i class="fas fa-question-circle" pTooltip="SMB Guideline" tooltipPosition="left"></i></a>
        </div>
        <div class="right">
            <a class="icon" (click)="companyInfor.toggle($event)"  tabindex="-1"><i class="fas fa-user" [pTooltip]="this.company" tooltipPosition="left"></i></a>
        </div>
        <!-- <div class="right" (click)="themeChooser.toggle($event)">
            <a class="icon"  tabindex="-1"><i class="fa fa-cog"></i></a>
        </div> -->
        <!-- <div class="right" (click)="showNotificationSidebar()">
            <a class="icon"  tabindex="-1"><i class="fa fa-bell"></i><span class="badge">5</span></a>
        </div> -->
        <!-- <div class="right" (click)="userdetails.toggle($event)">
            <a class="icon" tabindex="-1"><span [innerHtml]="user.Email" class="user-name"></span><i class="fa fa-user"></i></a>
        </div> -->
        <div class="right dropdown-header">
            <p-dropdown [options]="language" [(ngModel)]="locale" (onChange)="onLanguageChange()" placeholder="Language" [tabindex]="-1"></p-dropdown>
        </div>
        <div class="right" (click)="unrelease.toggle($event)">
            <button style="background-color: white; color: black;" pButton label="{{ 'MainMenu.cmdTool' | translate}}" icon="fas fa-cog" class="p-button-rounded p-button-info" tabindex="-1"></button>
        </div>
        <div class="right" (click)="closeAllWindows()">
            <button style="background-color: white; color: black;" pButton label="{{ 'MainMenu.CloseAllTab' | translate}}" icon="fas fa-times-circle" class="p-button-rounded p-button-info" tabindex="-1"></button>
        </div>
        <!-- <div class="right" (click)="query2Excel()">
            <button style="background-color: white; color: black;" pButton label="Query to Excel" icon="pi pi-reply" class="p-button-rounded p-button-info" tabindex="-1"></button>
        </div> -->
        <div class="right" style="padding-right: 30px; padding-bottom: 3px;">
            <h3>{{companyInformation.CpnyName}} - {{'Companyinfo.FiscalYear' | translate}} : {{companyInformation.FiscalYear}}</h3>
        </div>
    </div>
</div>
<div class="ng-header display-mobile">
    <div class="ng-header-left left">
        <div class="toggle-menu-button left">
            <a class="icon" (click)="toggleMenu()" tabindex="-1"><i class="fa fa-bars"></i></a>
        </div>
        <!-- <div class="left">
            <button style="background-color: white; color: black;" pButton label="{{ 'MainMenu.cmdHelp' | translate}}" class="p-button-rounded p-button-info" tabindex="-1"></button>
        </div> -->
    </div>
    <div class="ng-header-left right p-align-center">
        <div class="right">
            <button style="background-color: white; color: black;" pButton icon="fa fa-sign-out-alt" class="p-button-rounded"
            (click)="logout()" tabindex="-1" pTooltip="Log out" tooltipPosition="left"></button>
            <!-- <a class="icon" (click)="logout()"  tabindex="-1"><i class="fa fa-sign-out-alt" pTooltip="Log out" tooltipPosition="left"></i></a> -->
        </div>
        <div class="right dropdown-header">
            <p-dropdown [options]="language" [(ngModel)]="locale" (onChange)="onLanguageChange()" placeholder="Language" [tabindex]="-1"></p-dropdown>
        </div>
        <div class="right">
            <button style="background-color: white; color: black;" pButton icon="fas fa-question-circle" class="p-button-rounded"
            (click)="guildLine()" tabindex="-1" pTooltip="SMB Guideline" tooltipPosition="left"></button>
            <!-- <a class="icon" (click)="guildLine()"  tabindex="-1"><i class="far fa-question-circle" pTooltip="SMB Guideline" tooltipPosition="left"></i></a> -->
        </div>
        <div class="right">
            <button style="background-color: white; color: black;" pButton icon="fas fa-user" class="p-button-rounded"
            (click)="companyInfor.toggle($event)" tabindex="-1" [pTooltip]="this.company" tooltipPosition="left"></button>
            <!-- <a class="icon" (click)="companyInfor.toggle($event)"  tabindex="-1"><i class="fas fa-user" [pTooltip]="this.company" tooltipPosition="left"></i></a> -->
        </div>
        <div class="right" (click)="unrelease.toggle($event)">
            <button style="background-color: white; color: black;" pButton icon="fas fa-cog" class="p-button-rounded" tabindex="-1"></button>
        </div>
        <div class="right" (click)="closeAllWindows()">
            <button style="background-color: white; color: black;" pTooltip="{{ 'MainMenu.CloseAllTab' | translate}}" tooltipPosition="left" pButton icon="fas fa-times-circle" class="p-button-rounded" tabindex="-1"></button>
        </div>
    </div>
</div>
<!-- user detials overlay panel -->

<p-overlayPanel #companyInfor>
    <h3>{{this.company}}</h3>
    <div><b>User Name: </b><i [innerHtml]="user.UserName"></i></div>
    <div><b>Expiration Date: </b><i [innerHtml]="expiryDate | date:'dd-MM-yyyy'"></i></div>
</p-overlayPanel>

<p-overlayPanel #unrelease>
    <div *ngIf="showCP && commonService.demo == false" style="padding-top: 10px;">
        <p-dropdown [options]="dropdownYear" [(ngModel)]="year" (onChange)="yearChange()" placeholder="Year" [tabindex]="-1"></p-dropdown>
    </div>
    <div *ngIf="showCP" style="padding-top: 10px;">
        <p-dropdown [options]="money" [(ngModel)]="money_value" (onChange)="onMoneyChange()" placeholder="Money" [tabindex]="-1"></p-dropdown>
    </div>
    <div *ngIf="showCP" style="padding-top: 10px;" (click)="refreshCustomerPortal()"><button pButton label="{{ 'MainMenu.ReloadCP' | translate}}" icon="pi pi-refresh" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div *ngIf="showUnrelease" style="padding-top: 10px;" (click)="unRelease()"><button pButton label="{{ 'MainMenu.cmdUnrelease' | translate}}" icon="pi pi-reply" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div *ngIf="showUnrelease" style="padding-top: 10px;" (click)="deleteImportList()"><button pButton label="{{ 'MainMenu.cmdDeleteFuntion' | translate}}" icon="pi pi-trash" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div *ngIf="showUnrelease" style="padding-top: 10px;" (click)="deleteBatchList()"><button pButton label="{{ 'MainMenu.cmdDeleteBatch' | translate}}" icon="pi pi-trash" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div *ngIf="showImport" style="padding-top: 10px;" (click)="importTool()"><button pButton label="{{ 'MainMenu.cmdExcelImport' | translate}}" icon="pi pi-file-excel" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div *ngIf="companyCode == 'DEMOWEB'" style="padding-top: 10px;" (click)="restore()"><button pButton label="{{ 'MainMenu.cmdRestore' | translate}}" icon="pi pi-directions-alt" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div *ngIf="showUnrelease" style="padding-top: 10px;" (click)="salaryHRTranfer()"><button pButton label="{{ 'MainMenu.SalaryHRTranfer' | translate}}" icon="pi pi-reply" class="p-button-rounded p-button-info" tabindex="-1"></button></div>
    <div  *ngIf="showInventoryConfig" style="padding-top: 10px;" (click)="configIn.toggle($event)">
        <button pButton label="{{ 'MainMenu.InventoryConfig' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-info" tabindex="-1"></button>
    </div>
    <!-- <div *ngIf="showInventoryConfig" style="padding-top: 10px;">
        <p-dropdown [(ngModel)]="configIn" [options]="dropdownInventory" (onChange)="configInventory()" [tabindex]="-1">
            <ng-template pTemplate="item" let-item>
                {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
                {{item.label | translate}}
            </ng-template>
        </p-dropdown>
    </div> -->
</p-overlayPanel>

<p-overlayPanel #configIn>
    <div style="padding-top: 10px;" (click)="configInventory('1')"><button pButton label="{{ 'MainMenu.CostConfig' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('2')"><button pButton label="{{ 'MainMenu.CostingRateAllocationGroup' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('3')"><button pButton label="{{ 'MainMenu.CostingRateAllocationProduct' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('4')"><button pButton label="{{ 'MainMenu.CostingCenterGroupUsing' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('5')"><button pButton label="{{ 'MainMenu.CalculateQty154ForEachProduct' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('6')"><button pButton label="{{ 'MainMenu.CostingRateAllocationGroupSpecial' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('7')"><button pButton label="{{ 'MainMenu.CostingRateAllocationProductSpecial' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>
    <div style="padding-top: 10px;" (click)="configInventory('8')"><button pButton label="{{ 'MainMenu.Norms' | translate}}" icon="pi pi-cog" class="p-button-rounded p-button-success" tabindex="-1"></button></div>

</p-overlayPanel>

<!-- notifications sidebar -->
<p-sidebar [(visible)]="displayNotifications" position="right">
    <div *ngFor="let notification of notifications; let i=index" class="notification-message">
        <div><b>Message: </b><i [innerHtml]="notification.message"></i></div>
        <div><i>Created On: </i><i [innerHtml]="notification.createdOn | date:'dd/MM/yyyy'"></i></div>
    </div>
</p-sidebar>

<!-- theme chooser overlay panel -->
<p-overlayPanel #themeChooser >
    Select Theme:
    <div class="p-grid">
        <div class="p-col-4">
            <button pButton type="button" (click)="selectTheme('dark-theme')" style="background-color:#517fa4" tabindex="-1"></button>
        </div>
        <div class="p-col-4">
            <button pButton type="button" (click)="selectTheme('light-theme')" tabindex="-1"
                style="background-color:#C0C0C0"></button>
        </div>
        <div class="p-col-4">
            <button pButton type="button" (click)="selectTheme('green-theme')" tabindex="-1"
                style="background-color:#668014"></button>
        </div>
    </div>
</p-overlayPanel>
<!-- <p-dialog [modal]="true" header="Export" [(visible)]="queryExcel" [transitionOptions]="'0ms'"
    [style]="{width: commonService.dialogMobile ? '100vw' : '40vw'}" [baseZIndex]="1002">
    <div class="p-grid p-align-center">
        <div class="p-col-2">
            Time Out 
        </div>
        <div class="p-col-4">
            <input customInput type="text" id="timeout" pInputText pKeyFilter="num" class="no-padding-margin" [(ngModel)]="timeout">
        </div>
    </div>
    <div class="p-grid p-align-center">
        <div class="p-col-2">
            Query 
        </div>
        <div class="p-col-8">
            <input customInput type="text" id="query" pInputText class="no-padding-margin" [(ngModel)]="query">
        </div>
       
    </div>
    <div class="p-grid p-align-center">
        <div class="p-col-2">
        </div>
        <div class="p-col-4">
            <button pButton label="{{ 'Report.ExportXMLReport' | translate}}" icon="pi pi-file-excel"
                (click)="clickExport()" class="p-button-warning"></button>
        </div>
    </div>
</p-dialog> -->

<p-dialog [modal]="true" header="License" [(visible)]="displayLicense" [transitionOptions]="'0ms'"
    [style]="{width: commonService.dialogMobile ? '100vw' : '50vw'}" [baseZIndex]="1002" (onHide)="hideDialogLic()">
    <div class="p-grid">
        <div class="p-col-12" style="text-align: center;">
            <h1>{{ 'Message.Error.LicenseAboutExpire' | translate}}</h1>
            <h1>{{ 'Companyinfo.ExpirationDate' | translate}} : {{expiryDate | date:'dd-MM-yyyy'}}</h1>
        </div>
      </div>
</p-dialog>

<p-confirmDialog [baseZIndex]="1003" [style]="{width: commonService.dialogMobile ? '100vw' : '50vw'}" key="common"></p-confirmDialog>
<p-confirmDialog [baseZIndex]="1003" [style]="{width: commonService.dialogMobile ? '100vw' : '50vw'}" key="cp" [rejectVisible]="false" [acceptLabel]="'OK'"></p-confirmDialog>

<p-toast [style]="{marginTop: '20px'}" [baseZIndex]="1007"></p-toast>